<template>
  <ValidationObserver v-slot="{ invalid }">
    <!-- Recover Password Form -->
    <form
      class="chi-form"
      key="password"
      @submit.prevent="onReset"
      id="reset-form"
    >
      <div class="px-5 pt-6 pb-8 mb-4 flex flex-col my-2">
        <ChiInput
          type="email"
          rules="required|email"
          name="email"
          label="Email"
          placeholder="Your Registered E-mail"
          v-model="userName"
        />

        <div class="flex items-center justify-between">
          <input
            type="submit"
            :disabled="invalid"
            class="btn btn-purple"
            value="Recover Password"
          />
          <router-link :to="{ name: 'Login' }">
            <small>Login</small>
          </router-link>
        </div>
      </div>
    </form>

    <div
      class="flex flex-col justify-center items-center border-t border-purple-ap-t03 -mx-5 px-5 pt-5"
    >
      <p class="mb-5 text-center font-semibold text-sm">
        <router-link :to="{ name: 'Apply' }">
          Don't have an account yet?
          <br />Start today and review our Au Pairs, it's free!
        </router-link>
      </p>
    </div>
  </ValidationObserver>
</template>

<script>
import ChiInput from "@/components/Forms/ChiInput.vue";

export default {
  name: "ForgotForm",
  components: {
    ChiInput,
  },
  data() {
    return {
      userName: "",
    };
  },
  methods: {
    onReset() {
      this.$emit("form-submitted", { userName: this.userName });
    },
  },
};
</script>
